import { useContext } from 'react';

import { LocalizationContext } from '@hrworks/localization';

import { Button } from '../Button';
import { S } from './ConfirmationModal.styles';
import type { ConfirmationModalProps } from './ConfirmationModal.types';

export const ConfirmationModal = ({
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  isConfirmEnabled,
  ...otherProps
}: ConfirmationModalProps) => {
  const { translate } = useContext(LocalizationContext);

  return (
    <S.ConfirmationModal
      closeable
      onClose={onCancel}
      footer={
        <>
          {onCancel && (
            <Button variant="subtle" onClick={onCancel}>
              {cancelText || translate('confirmation-modal-cancel')}
            </Button>
          )}
          {onConfirm && (
            <Button variant="subtle" disabled={!isConfirmEnabled} onClick={onConfirm}>
              {confirmText || translate('confirmation-modal-confirm')}
            </Button>
          )}
        </>
      }
      {...otherProps}
    />
  );
};
